<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9924yF/tc-custom/9781398428324.jpg?1692133225001" alt="This image is the cover for the book Maisy's Memories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maisy's Memories
      </h1>
      <p class="bookDescription body article font2">
        <p>Dealing with loss is a difficult thing for anyone to go through, no matter what the age. For adults dealing with the loss of a loved one, it can add even more stress to an already difficult situation, while having to take care of their children as well. Most adults try to put on a ‘brave face’ in front of their children and pretend that everything is okay. This heart-warming story explains how the deceased can always live on in our memories and conveys the message, ‘It is okay not to be okay.’ This book also deals with the vulnerability of adults and their emotions. It shows children that sometimes adults can get upset too. When Daddy is upset about Nan dying, Maisy aged 7 years old is the one that cheers him up. Sometimes grown-ups need some moral support and that’s exactly what Maisy gives him when she plants a flowerbed in memory of her Nan. Although this book will always be relevant as death and grief are part of the human cycle, it is of particular relevance at a time when not everyone has been able to attend funerals and grieve in a way that offers a sense of closure. This story offers a new insight into how to hold on to and cherish the memories that we have.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Tracey
      </h2>
      
      <p class="authorDescription body article">Sarah Tracey is a newly published Irish author with a background in primary school teaching and a love for drama in education. She has a passion for turning the harsh realities of life into heart-warming stories, which children can relate to and enjoy in a way in which they can empathise with the characters.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60ad7776